"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterPage = void 0;
const header_1 = require("@components/header");
const React = __importStar(require("react"));
require("./styles.scss");
const react_router_1 = require("react-router");
const portfolio_page_1 = require("@pages/portfolio-page");
const graph_page_1 = require("@pages/graph-page");
const MasterPage = (props) => {
    return (React.createElement("div", { className: "p-master-page" },
        React.createElement(header_1.Header, null),
        React.createElement(react_router_1.Switch, null,
            React.createElement(react_router_1.Route, { path: "/portfolio", component: portfolio_page_1.PortfolioPage }),
            React.createElement(react_router_1.Route, { path: "/", component: graph_page_1.GraphPage }))));
};
exports.MasterPage = MasterPage;
